/**
 * True only for the null→user auth transition — a genuine login on this
 * browser. Token refreshes (user→user), sign-outs (user→null), and account
 * switches all return false. Callers combine this with the Supabase event
 * name (`SIGNED_IN`) so an INITIAL_SESSION restore on page load never counts
 * as a login.
 */
export function isLoginTransition(
  prevUserId: string | null,
  nextUserId: string | null
): boolean {
  return prevUserId === null && nextUserId !== null;
}
